import { render } from "./CitasPorMedico.vue?vue&type=template&id=5403cbe6&scoped=true"
import script from "./CitasPorMedico.vue?vue&type=script&lang=js"
export * from "./CitasPorMedico.vue?vue&type=script&lang=js"

import "./CitasPorMedico.vue?vue&type=style&index=0&id=5403cbe6&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5403cbe6"]])

export default __exports__